import { OktonAuthPage, OktonInput } from '@okton/platform-ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, HStack, Link as ChakraLink } from '@chakra-ui/react';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { LuAtSign } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import * as yup from 'yup';

type ForgotFormData = {
  email: string;
};

const forgotFormSchema = yup.object().shape({
  email: yup.string().required('E-mail obrigatório').email('E-mail inválido'),
});

const Forgot: React.FC = () => {
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(forgotFormSchema),
  });

  const { isSubmitting, errors } = formState;

  const handleForgot: SubmitHandler<ForgotFormData> = async () => {
    await new Promise(resolve => setTimeout(resolve, 2000));
  };

  return (
    <OktonAuthPage
      title="Não consegue entrar?"
      onSubmit={handleSubmit(handleForgot)}
      footer={
        <HStack justify="center">
          <Link to="/login">
            <ChakraLink as="div" color="blue.500" fontSize="sm">
              Voltar à página de entrada
            </ChakraLink>
          </Link>
        </HStack>
      }
    >
      <OktonInput
        type="email"
        label="A gente vai mandar um link de recuperação para"
        error={errors.email}
        leftIcon={LuAtSign}
        {...register('email')}
      />

      <Button type="submit" mt="6" isLoading={isSubmitting}>
        Enviar link de recuperação
      </Button>
    </OktonAuthPage>
  );
};

export default Forgot;
